"use client";
import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from "next/image";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <>
      {isReadMore ? text.slice(0, 203) : text}
      <div
        onClick={toggleReadMore}
        className="style-redmore"
        style={{
          color: "#D5AF34",
          fontSize: "17px",
          display: "inline-block",
          marginLeft: "5px",
        }}
      >
        {isReadMore ? "Read More " : "Show less"}
      </div>
    </>
  );
};
function Content({ Mydata }) {
  const data = Mydata[1];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="mx-auto max-w-7xl px-5">
      <Slider {...sliderSettings} className="custom-slider-width pb-10 ">
        {data.third_trusted.map((item, index) => (
          <div key={index} className="mt-4 pt-2 px-4 sm:mt-7 md:mt-7 lg:mt-7">
            <div className="text-center flex flex-col items-center justify-between ">
              <div className="flex justify-center h-16 mb-3 z">
                <Image src={item.image} height={60} width={80} alt={item.alt} title={item.tle} />
              </div>
              <h3 className="updatedheading mb-3">{item.title}</h3>
              <div className="updatedparapremu ">{item.des}</div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Content;
